import { compact } from '../../../../helpers/compact';
import { HomeSliceType, PublicationsSlice } from '../../../../types/slice';
import { toLink, toText } from '../../fields';

const publicationsSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): PublicationsSlice | undefined => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }

  const title = toText(data.primary?.title);
  const ctaLabel = toText(data.primary?.CTALabel);
  const ctaLink = toLink(data.primary?.CTALink);

  if (!title || !ctaLabel || !ctaLink) {
    return undefined;
  }

  return compact({
    type: HomeSliceType.PUBLICATIONS,
    title,
    ctaLabel,
    ctaLink,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tiles: data?.items?.map((item: Record<string, any>) => {
      return {
        title: item?.title,
        date: item?.date,
        relatedMedia: toLink(item?.related_media),
      };
    }),
  });
};

export default publicationsSlice;
